import { render, staticRenderFns } from "./HoursDetail.vue?vue&type=template&id=1cb968ee&scoped=true&"
import script from "./HoursDetail.js?vue&type=script&lang=js&"
export * from "./HoursDetail.js?vue&type=script&lang=js&"
import style0 from "./HoursDetail.scss?vue&type=style&index=0&id=1cb968ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cb968ee",
  null
  
)

export default component.exports